const { m } = require('minthril');
const { Button } = require('../../button');
const { formatMoney } = require('../../../business');

function ProductDetail() {
  let selectedImageUrl = null;
  let selectedProductId = null;
  let selectedVariantId = null;
  let quantity = 1;

  return {
    view: ({ attrs: { product, onAdd, redraw, cartQuantities = {} } }) => {
      const variants = product.variants?.nodes || [];
      const images = product.images?.nodes?.length ? product.images.nodes : [product.featuredImage].filter(Boolean);

      if (selectedProductId !== product.id) {
        selectedProductId = product.id;
        selectedImageUrl = images[0]?.url || null;
        selectedVariantId = variants[0]?.id || null;
        quantity = 1;
      }

      const variant = variants.find(item => item.id === selectedVariantId) || variants[0];
      const price = variant?.price || product.priceRange.minVariantPrice;
      const selectedImage = images.find(image => image.url === selectedImageUrl) || images[0];
      const productUrl = `${window.location.origin}/products/${product.handle}`;
      const productSchema = {
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: product.title,
        description: product.description || '',
        url: productUrl,
        image: images.map(image => image.url),
        offers: variants.filter(item => item.price).map(item => ({
          '@type': 'Offer',
          url: productUrl,
          priceCurrency: item.price.currencyCode,
          price: item.price.amount,
          availability: item.availableForSale
            ? 'https://schema.org/InStock'
            : 'https://schema.org/OutOfStock'
        }))
      };

      return m('article.product-detail',
        m('script', { type: 'application/ld+json' }, JSON.stringify(productSchema)),
        m('a.product-detail__back', { href: '/' }, '← Back to parts'),
        m('div.product-detail__layout',
          m('div.product-detail__visual',
            m('div.product-detail__image', selectedImage
              ? m('img', { src: selectedImage.url, alt: selectedImage.altText || product.title })
              : m('span', 'No image')
            ),
            images.length > 1 ? m('div.product-detail__gallery',
              images.map(image => m('button.product-detail__thumbnail', {
                class: image.url === selectedImage?.url ? 'is-active' : '',
                type: 'button',
                onclick: () => {
                  selectedImageUrl = image.url;
                  redraw();
                }
              }, m('img', { src: image.url, alt: image.altText || product.title, loading: 'lazy' })))
            ) : null
          ),
          m('div.product-detail__copy',
            m('p.products__eyebrow', product.productType || 'Performance parts'),
            m('h1', product.title),
            price ? m('p.product-detail__price',
              variant?.compareAtPrice
                ? m('s.product-detail__compare-price', formatMoney(variant.compareAtPrice.amount, variant.compareAtPrice.currencyCode))
                : null,
              formatMoney(price.amount, price.currencyCode)
            ) : null,
            m('div.product-detail__rule'),
            product.descriptionHtml
              ? m('div.product-detail__description', { innerHTML: product.descriptionHtml })
              : m('p.product-detail__description', product.description || 'A considered component for a faster, more capable machine.'),
            variants.length > 1 ? m('div.product-detail__variants',
              m('p.product-detail__variants-label', 'Choose a variant'),
              m('div.product-detail__variant-options', variants.map(item => m('button.product-detail__variant', {
                class: item.id === variant?.id ? 'is-selected' : '',
                type: 'button',
                disabled: !item.availableForSale,
                onclick: () => {
                  selectedVariantId = item.id;
                  redraw();
                }
              }, item.title)))
            ) : null,
            variant
              ? variant.availableForSale
                ? m('div.product-detail__purchase',
                  m('label.product-detail__quantity',
                    m('span', 'Quantity'),
                    m('input', {
                      type: 'number',
                      min: 1,
                      value: quantity,
                      oninput: event => { quantity = Math.max(1, Number(event.target.value) || 1); redraw(); }
                    })
                  ),
                  m(Button, { onclick: () => onAdd(variant.id, quantity) }, 'Add to cart'),
                  cartQuantities[variant.id]
                    ? m('span.product-detail__cart-quantity', `In cart (${cartQuantities[variant.id]})`)
                    : null
                )
                : m('p.product-detail__unavailable', 'Currently unavailable')
              : null
          )
        )
      );
    }
  };
}

function ProductPage() {
  return {
    view: ({ attrs }) => m(ProductDetail, attrs)
  };
}

module.exports = { ProductPage };
